import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=e40d184e&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=e40d184e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40d184e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e40d184e')) {
      api.createRecord('e40d184e', component.options)
    } else {
      api.reload('e40d184e', component.options)
    }
    module.hot.accept("./exchange.vue?vue&type=template&id=e40d184e&scoped=true&", function () {
      api.rerender('e40d184e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vip/exchange.vue"
export default component.exports